// extracted by mini-css-extract-plugin
export default {"title":"chartheader_title__Ke0KE"};